import type { ReactNode } from 'react';

export const symbol_outgoing_mail: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M765-280H614q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h151l-52-53q-8-9-8.5-21t8.5-21q9-9 21-9t21 9l104 104q5 5 7 10t2 11q0 6-2 11t-7 10L755-185q-9 9-21 9t-21-9q-9-9-8.5-21t8.5-21l52-53Zm-625 0q-24.75 0-42.37-17.63Q80-315.25 80-340v-440q0-24.75 17.63-42.38Q115.25-840 140-840h560q24.75 0 42.38 17.62Q760-804.75 760-780v202q0 12-9.05 21-9.06 9-21.13 9-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-155L416-532 140-732v392h321q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Zm36-500 240 174 246-174H176Zm-36 440v-440 440Z"
		/>
	</svg>
);
